import { type CMSArrayBase, type CMSGroupParams, createCmsUrl } from './base';

export interface ICMSWageringByVolatility extends CMSArrayBase, CMSGroupParams {
  gridGames: string;
  groupsInclude: string;
}

export const getWageringByVolatilityUrl = () =>
  createCmsUrl({
    path: 'wagering-by-volatilities',
    queryData: { sort: 'id:asc' },
  });
